module.exports = __webpack_public_path__ + "static/canvas@2x-bce7cc46e2ceffbf57a8928eb1b1b27d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/canvas@2x.jpg
// module id = 2586
// module chunks = 168707334958949